import { c as _c } from "react/compiler-runtime";
import request from '@onefootprint/request';
import type { Organization } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { DASHBOARD_AUTHORIZATION_HEADER } from '@/config/constants';
const getAuthRoles = async ({
  authToken
}: {
  authToken: string;
}) => {
  const {
    data
  } = await request<Organization[]>({
    method: 'GET',
    url: '/org/auth/roles',
    headers: {
      [DASHBOARD_AUTHORIZATION_HEADER]: authToken
    }
  });
  return data;
};
const useAuthRoles = authToken => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== authToken) {
    t0 = ["get-roles", authToken];
    t1 = () => getAuthRoles({
      authToken
    });
    $[0] = authToken;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!authToken;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
};
export default useAuthRoles;